import Pagination from "./Pagination";
import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useHistory, useLocation } from "react-router-dom";
import { TokenContext } from "./TokenContext";
import Repo from "../Utility/Repo";
import ModalComponent from "./ModalComponent";
import Badge from "./Badge";
import UserDataComponent from "./UserDataComponent";

const ListPaymemtsUsers = (props) => {
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [showModalMail, setShowModalMail] = useState(false);
  //const [showModal, setShowModal] = useState(false);
  const [selectedIUV, setSelectedIUV] = useState("");
  const apiToken = useContext(TokenContext);
  const [file, setFile] = useState();
  const [hasMail, setHasMail] = useState(false);

  let history = useHistory();
  const { operator, userData, delegate, user, citizen } = UserDataComponent();

  const [formData, setFormData] = useState({
    iuv: "", // Assegna il valore di `id` a `formData.Iuv` se `id` esiste, altrimenti assegna una stringa vuota
    descrizione: "",
  });

  const [error, setError] = useState("");

  const toggleModalDetail = () => {
    setShowModalDetail(!showModalDetail);
    // Azzeramento dei campi qui
    setFormData({
      iuv: "",
      descrizione: "",
    });
    setError("");
  };

  //setUserId(props.userId);

  const toggleModalMail = () => {
    setShowModalMail(!showModalMail);
    // Azzeramento dei campi qui
    setError("");
  };

  const showPayments = (id) => {
    Repo.getIuvUser(apiToken, id, true)
      .then((response) => {
        if (response.status == 200) {
          setFile();
          var obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + response.data;
          setFile(obj);
          toggleModalShowFile(!showFileToggle);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSaveSendMail = () => {
    Repo.postSendEmail(apiToken, selectedIUV, props.userId)
      .then((response) => {
        if (response.status == 200) {
          setShowModalDetail(false);
          setSelectedIUV("");
          window.location.reload();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });
    // Resetta l'errore
    setError("");
  };

  const handleSave = (iuv) => {
    //alert(formData.Iuv);
    // Effettua la validazione dei dati
    if (!formData.descrizione) {
      setError("Il campo descrizione è obbligatorio!");
      return;
    }

    if (formData.descrizione.length > 300) {
      setError("Il campo Descrizione deve essere massimo 300 caratteri!");
      return;
    }

    setFormData({
      iuv: iuv,
      descrizione: formData.descrizione,
    });
    console.log(formData.descrizione + "iuv:" + iuv);
    const data = {
      iuv: iuv,
      descrizione: formData.descrizione,
    };

    Repo.poutUpdatePaidOp(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          setShowModalDetail(false);
          setSelectedIUV("");
          window.location.reload();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });

    // Resetta i valori del form dopo il salvataggio
    setFormData({
      iuv: "",
      descrizione: "",
    });

    // Resetta l'errore
    setError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const showDetail = (id) => {
    setSelectedIUV(id);
    setShowModalDetail(true);
  };

  const sendPayments = (id) => {
    setSelectedIUV(id);
    setShowModalMail(true);
  };

  const handleCloseModal = () => {
    console.log("chiudo la modale");
    setFormData({
      iuv: "",
      descrizione: "",
    });
    setShowModalDetail(false);
  };

  const bodyDetail = (id) => {
    return (
      <>
        <div className="row mb-lg-3">
          In seguito potrai verificare lo stato del flusso dalla sezione 'Flussi
          MyPay' {id}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="Iuv">Iuv:</label>
              <input type="text" id="Iuv" name="Iuv" value={id} readOnly />
            </div>
            <div>
              <label htmlFor="descrizione">Descrizione:</label>
              <textarea
                id="descrizione"
                name="descrizione"
                value={formData.descrizione}
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="d-flex justify-content-end">
              {!error && (
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => handleSave(id)}
                >
                  Salva come pagato
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const handleCloseModalMail = () => {
    console.log("chiudo la modale Mail");

    setShowModalMail(false);
  };

  const bodyMail = (id) => {
    return (
      <>
        <div className="row mb-lg-3">
        Premendo Invia Email, il cittadino riceverà il bollettino PagoPa. Solo chi ha fornito un'email registrata riceverà la comunicazione. {props.userId}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="Iuv">Iuv:</label>
              <input type="text" id="Iuv" name="Iuv" value={id} readOnly />
            </div>
            <div></div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const doPayment = (iuv, fiscalCode) => {
    if (props.fiscalCode) {
      Repo.getPayment(apiToken, iuv, fiscalCode, window.location.href)
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      Repo.getPayment(apiToken, iuv, null, window.location.href)
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <>
      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom no-after">
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-10">
                <h4>Pagamenti</h4>
              </div>
              {props.goBack && (
                <div className="col-2  text-right">
                  <button
                    className="btn btn-info"
                    onClick={() => history.goBack()}
                  >
                    <svg className="icon icon-white icon-sm">
                      <use href={`${iconSprite}#it-arrow-left`} />
                    </svg>
                    <a className="text-white">Indietro</a>
                  </button>
                </div>
              )}
            </div>

            {props.payments && props.payments.length > 0 ? (
              props.payments.map((x, index) => (
                <div
                  key={x.id}
                  style={
                    x.isPagato == true
                      ? {
                          borderLeft: "4px solid #008758",
                        }
                      : {
                          borderLeft: "4px solid #d9364f",
                        }
                  }
                  {...(x.isPagato == true && {
                    className: "",
                  })}
                >
                  <div className="row mt-4 ml-3">
                    <div className="col-12">
                      {x.titolo ? x.titolo : "Pagamento"}
                    </div>

                    <div className="w-100 sl-h10"></div>

                    <div className="col-lg-3">
                      Importo dovuto:
                      <span className="fw-semibold">
                        <b>
                          {" "}
                          {x.importoDovuto &&
                            parseFloat(x.importoDovuto).toLocaleString(
                              "it-IT"
                            )}{" "}
                          €
                        </b>
                      </span>
                      <div className="clear"></div>
                      <span>
                        {" "}
                        Importo pagato:{" "}
                        <b>
                          {x.isPagato == true ? (
                            <>
                              {x.importoTotalePagato &&
                                parseFloat(
                                  x.importoTotalePagato
                                ).toLocaleString("it-IT")}{" "}
                              €
                            </>
                          ) : (
                            "0 €"
                          )}
                        </b>
                      </span>
                    </div>

                    <div className="col-lg-4 col-md-3 mb-3">
                      {x.isPagato == true ? (
                        <Badge badgeStatus="bg-success" badgeText="Pagato" />
                      ) : (
                        <Badge badgeStatus="bg-danger" badgeText="Da pagare" />
                      )}
                      {x.isEmailSent == true ? (
                        <Badge
                          badgeStatus="bg-success"
                          badgeText="Email inviata"
                        />
                      ) : (
                        <Badge
                          badgeStatus="bg-danger"
                          badgeText="Email non inviata"
                        />
                      )}
                    </div>

                    {!x.isPagato && !citizen && (
                      <>
                        <div className="col text-right">
                          <button
                            className="btn btn-outline-primary p-2"
                            onClick={() => showDetail(x.codIuv)}
                            disabled={delegate}
                          >
                            &nbsp;
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-pencil`} />
                            </svg>{" "}
                            Dettagli
                          </button>
                        </div>
                      </>
                    )}

                    {x.isPagato && (
                      <div className="col text-right">
                        <button
                          className="btn btn-outline-primary p-2"
                          onClick={() => showPayments(x.codIuv)}
                        >
                          <svg className="icon icon-primary">
                            <use href={`${iconSprite}#it-file`} />
                          </svg>
                          &nbsp; Visualizza
                        </button>
                      </div>
                    )}



                    {!x.isPagato && (
                      <>
                        <div className="col text-right">
                          <button
                            className="btn btn-outline-primary p-2"
                            onClick={() => showPayments(x.codIuv)}
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-file`} />
                            </svg>
                            &nbsp; Visualizza
                          </button>
                        </div>

                        <div className="col text-right">
                          <button
                            className="btn btn-outline-primary p-2"
                            onClick={() => sendPayments(x.codIuv)}
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-mail`} />
                            </svg>
                            &nbsp; Invia email
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <>Non ci sono pagamenti</>
            )}

            {props.paymentsTemp && (
              <Pagination
                items={props.paymentsTemp}
                setCurrentItems={props.setPayments}
                itemsPerPage={5}
              ></Pagination>
            )}
          </div>
        </div>
      </div>
      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>
      <ModalComponent
        toggleModal={toggleModalDetail}
        isOpen={showModalDetail}
        header="Dettagli"
        body={bodyDetail(selectedIUV)}
        buttonDeny="Chiudi"
        onClose={handleCloseModal}
      />


<ModalComponent
        labelledBy="modalEmail"
        toggleModal={toggleModalMail}
        isOpen={showModalMail}
        header="Invia email con il bollettino"
        body={bodyMail(selectedIUV)}
        buttonConfirm="Invia email"
        buttonDeny="Annulla"
        function={() =>  handleSaveSendMail()}
      ></ModalComponent>


    </>
  );
};

export default ListPaymemtsUsers;
